import React from 'react';

import Dialog from 'components/Dialog';
import RosteredDevice from './RosteredDevice';

export type RosteredDeviceDialogProps = {
  name: string;
  deviceUid: string;
  onRequestHide?: () => void;
  onComplete?: () => void;
};

const RosteredDeviceDialog = ({
  name,
  deviceUid,
  onRequestHide,
  onComplete,
}: RosteredDeviceDialogProps): JSX.Element => {
  return (
    <Dialog title="Cannot remove contact information" size="xsmall" onRequestHide={onRequestHide}>
      <RosteredDevice name={name} deviceUid={deviceUid} onComplete={onComplete}/>
    </Dialog>
  );
};

export default RosteredDeviceDialog;
